module.exports = __webpack_public_path__ + "img/side-image.61d16de7.jpeg";